/**
 * @generated SignedSource<<bab3dd51d00db1a02819da38fc94c6fc>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type LinkedContentInput_images$data = ReadonlyArray<{
  readonly " $fragmentSpreads": FragmentRefs<"LinkedContent_images">;
  readonly " $fragmentType": "LinkedContentInput_images";
}>;
export type LinkedContentInput_images$key = ReadonlyArray<{
  readonly " $data"?: LinkedContentInput_images$data;
  readonly " $fragmentSpreads": FragmentRefs<"LinkedContentInput_images">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "LinkedContentInput_images",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "LinkedContent_images"
    }
  ],
  "type": "Image",
  "abstractKey": null
};

(node as any).hash = "0ecd9b284b44d0003f34dbb6ffdd1fae";

export default node;
